import React from 'react'
import styled from 'styled-components'
import { Container, MOBILE } from '../CustomLanding.styled'
import { colors, pains } from '../content'

const PainPoints: React.FC = () => (
	<Section>
		<Split>
			<Title>
				{pains.titleStart}
				<Highlight>{pains.titleHighlight}</Highlight>
				<span>{pains.titleEmoji}</span>
			</Title>
			<ListCol>
				<Rows>
					{pains.rows.map(row => (
						<Row key={row}>{row}</Row>
					))}
					<RowMuted>{pains.rowMuted}</RowMuted>
				</Rows>
				<Resolution>{pains.resolution}</Resolution>
			</ListCol>
		</Split>
	</Section>
)

export default PainPoints

const Section = styled.section`
	background: ${colors.navy};
	color: ${colors.paper};
	padding: 64px 0;
	${MOBILE} {
		padding: 40px 0;
	}
`

const Split = styled(Container)`
	display: flex;
	flex-wrap: wrap;
	gap: 48px 72px;
	/* centered against the compact list so the short title doesn't leave a
	   large empty band under it on wide screens */
	align-items: center;
	${MOBILE} {
		display: block;
	}
`

const Title = styled.h2`
	flex: 1 1 380px;
	min-width: 0;
	font-weight: 700;
	font-size: clamp(24px, 2.2vw, 34px);
	line-height: 1.4;
	color: #ffffff;
	margin: 0;
	${MOBILE} {
		font-size: 27px;
		line-height: 1.45;
		margin-bottom: 26px;
	}
`

const Highlight = styled.span`
	color: ${colors.amber};
`

const ListCol = styled.div`
	flex: 1 1 380px;
	min-width: 0;
`

const Rows = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 26px;
`

const Row = styled.div`
	padding: 13px 0;
	border-bottom: 1px solid rgba(245, 245, 245, 0.16);
	font-size: 17px;
	line-height: 1.75;
	color: rgba(245, 245, 245, 0.85);
	${MOBILE} {
		padding: 16px 0;
		font-size: 16px;
		line-height: 1.85;
	}
`

const RowMuted = styled.div`
	padding: 13px 0;
	font-size: 17px;
	line-height: 1.75;
	color: rgba(245, 245, 245, 0.6);
	${MOBILE} {
		padding: 16px 0;
		font-size: 16px;
		line-height: 1.85;
	}
`

const Resolution = styled.p`
	margin: 0;
	font-size: 18px;
	line-height: 1.85;
	color: #ffffff;
	font-weight: 500;
	border-inline-start: 3px solid ${colors.red};
	padding-inline-start: 20px;
	${MOBILE} {
		font-size: 17px;
		line-height: 1.9;
		padding-inline-start: 16px;
	}
`
